import React, { useEffect, useState } from 'react';
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import search from "../../../assets/search.png";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { Dialog, DialogActions, DialogContent, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import axiosInstanceSM from '../../../Utils/axiosSm';

function AllTeachers() {
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  const columns = [
    { id: "id", label: "ID" },
    { id: "Photo", label: "Photo", minWidth: "50px" },
    { id: "TeacherName", label: "Teacher Name", minWidth: "150px" },
    { id: "Qualification", label: "Qualification", minWidth: "100px" },
    { id: "Class&Course", label: "Class & Course", minWidth: "160px" },
    { id: "Experience", label: "Experience", minWidth: "100px" },
    { id: "Subject", label: "Subject", minWidth: "100px" },
    { id: "Description", label: "Description" },
    { id: "Action", label: "Action", minWidth: "120px" },
  ];
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const [image, setImage] = useState(null);
  const [teacherName, setTeacherName] = useState('');
  const [subject, setSubject] = useState('');
  const [course, setCourse] = useState();
  const [experience, setExperience] = useState();
  const [year, setYear] = useState('');
  const [description, setDescription] = useState('');
  const [chips, setChips] = useState([]);
  const [deleteID, setDeleteId] = useState();
  const [editId, setEditId] = useState('');
  const handleCloseDelete = () => { setOpen(false) };
  const handleClose = () => { setOpenNew(false) };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInKB = file.size / 1024;
        if (fileSizeInKB > 100) {
              toast.error("File size must be less than 100 KB");
            return;
          }    
                  const img = new Image();
                  img.onload = function() {
                      if (img.width !== img.height) {
                          toast.error("Please upload a square image (equal width and height)");
                          setImage('');
                          setImagePreview('');
                      } else {
                        setImage(file);
                        const Imageurl = (URL.createObjectURL(file));
                        setImagePreview(Imageurl);
                      }
                  };
                  img.onerror = function() {
                      toast.error("Error loading image");
                  };
                  img.src = URL.createObjectURL(file);
              }
          };

  async function fetchFaculty() {
    const d = new Date();
    let text = d.toLocaleDateString();
    let token = `abcd1234${text}`;
    const payload = { token: token };
    try {
      const response = await axiosInstanceSM.post("api/v1/expertFaculties", payload);
      setData(response.data.data)
    } catch (error) {
      if (error.response.data) {
      }
    }
  };

  useEffect(() => {
    fetchFaculty();
  }, []);

  const handleDelete = async () => {
    const payload = {
      token: 'abc1234',
      _method: 'DELETE',
    };
    try {
      const response = await axiosInstanceSM.delete(`api/v1/expertFaculty/${deleteID}`, { data: payload });
      if (response.data.success === true) {
        toast.success(response.data.message);
        setData((prevData) => prevData.filter((item) => item.id !== deleteID))
        setOpen(false);
      } else {
        toast.error(response.data.message)
      }
    }
    catch (error) {
    }
  };

  async function fetchEdit(id) {
    setOpenNew(true);

    const payload = { token: 'abc123' }
    try {
      const response = await axiosInstanceSM.post(`api/v1/expertFaculty/${id}`, payload);
      setTeacherName(response.data.data.facultyName);
      setChips(response.data.data.facultyQualification);
      setSubject(response.data.data.facultySubject);
      setCourse(response.data.data.facultyClass);
      setExperience(response.data.data.facultyExperiance);
      setDescription(response.data.data.facultyDescription);
      setYear(response.data.data.facultyYear);
      setImagePreview(response.data.data.facultyImage);
      setEditId(id);
    }
    catch (error) {

    }

  }

  const handleEditSubmit = async (e) => {
    e.preventDefault()
    const formdata = new FormData();
    formdata.append('facultyName', teacherName);
    formdata.append('facultyQualification', chips)
    formdata.append('facultySubject', subject)
    formdata.append('facultyClass', course)
    formdata.append('facultyExperiance', experience)
    formdata.append('facultyYear', year)
    if(image){
      formdata.append('facultyImage', image)
    }
    formdata.append('facultyDescription', description);
    formdata.append("token", "abcd123");
    formdata.append("_method", "PUT");
    try {
      const response = await axiosInstanceSM.post(`/api/v1/expertFaculty/${editId}`, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success === true) {
        toast.success(response.data.message)
        fetchFaculty();
        setOpenNew(false);
      }
    }
    catch (error) {
      if (error.response) {
        toast.error(error.response.data.message || 'Something went wrong!');
      }
    }
  }

  return (<>
    <div
      style={{
        width: "100%",
        height: "4rem",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        marginTop: "0rem",
        display: "flex",
        alignItems: "center",
        padding: "1rem",
        justifyContent: "space-between",
        boxShadow: "0px 4px 4px 2px rgb(231, 231, 231)",
      }}
    >
      <span style={{ color: "#CB8B65", fontSize: "1.2rem", fontWeight: "600" }}>
        Expert Faculty List
      </span>
      <div style={{ display: "flex", alignItems: "center" }}>
        <InputGroup>
          <Form.Control
            placeholder="Search...."
            aria-label="Recipient's userBoardName"
            aria-describedby="basic-addon2"
          />
          <Button style={{ backgroundColor: "#CB8B65", border: 0 }}>
            <img src={search} alt="" />
          </Button>
        </InputGroup>
      </div>
    </div>

    <Paper sx={{ width: "96%", overflow: "hidden", scrollBehavior: "smooth", marginLeft: "1rem", marginTop: '30px' }}>
      <TableContainer sx={{ maxHeight: 360 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{
                    minWidth: column.minWidth,
                    backgroundColor: "#CB8B65",
                    fontWeight: "500",
                    color: "#ffffff",
                    fontSize: "1.1rem",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(data) && data.map((item, index) => (
              <TableRow key={item.id} hover>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <img style={{ borderRadius: '50%' }} height={30} width={30} src={item.facultyImage} alt="" />
                </TableCell>
                <TableCell>{item.facultyName}</TableCell>
                <TableCell>{item.facultyQualification}</TableCell>
                <TableCell>{item.facultyClass}</TableCell>
                <TableCell>{item.facultyExperiance} {item.facultyYear}</TableCell>
                <TableCell>{item.facultySubject}</TableCell>
                <TableCell>
                  <OverlayTrigger
                    placement="left"
                    delay={{ show: 400, hide: 400 }}
                    overlay={<Tooltip id="button-tooltip">{item.facultyDescription}</Tooltip>}
                  >
                    <TextSnippetIcon />
                  </OverlayTrigger>
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => { fetchEdit(item.id) }}>
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => { setDeleteId(item.id); setOpen(true); }}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>

        </Table>
      </TableContainer>
    </Paper>



    <Dialog open={openNew} onClose={handleClose} fullWidth={true} maxWidth="xl">
      <DialogContent>
        <form onSubmit={handleEditSubmit} encType='mutipart/form-data'>
          <div
            style={{ width: "100%", height: "4rem", backgroundColor: "#ffffff", borderRadius: "10px", marginTop: "0rem", display: "flex", alignItems: "center", padding: "1rem", justifyContent: "space-between", boxShadow: "0px 4px 4px 2px rgb(231, 231, 231)", }}
          >
            <span style={{ color: "#CB8B65", fontSize: "1.2rem", fontWeight: "600" }}>
              Expert Faculty
            </span>
            <button type='submit' style={{ backgroundColor: '#CB8B65', padding: '10px 15px', color: 'white', borderRadius: '10px' }}>Publish</button>
          </div>

          <div style={{ padding: '1rem 1.5rem 0.5rem 1.5rem', fontSize: '20px' }}>Edit Expert Faculty</div>
          <hr style={{ margin: '0px', border: '1px solid' }} />

          <div style={{ padding: '1rem 1.5rem', display: 'flex', flexDirection: "column", gap: '20px' }}>
            <div style={{ display: 'flex', gap: '20px',flexDirection:isXs ? "":'column'}}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Faculty Name</label>
                <input onChange={(e) => setTeacherName(e.target.value)} value={teacherName} required style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }} type="text" placeholder="Enter Faculty Name" />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Qualification</label>
                <input style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }}
                  type="text"
                  placeholder="Enter Qualification"
                  value={chips}
                  onChange={(e) => setChips(e.target.value)}
                />

              </div>
            </div>
            <div style={{ display: 'flex', gap: '20px', flexDirection:isXs ? "":'column' }}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Expertise Subject</label>
                <input onChange={(e) => setSubject(e.target.value)} value={subject} required style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }} type="text" placeholder=" Enter Expertise Subject" />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Class & Course</label>
                <input onChange={(e) => setCourse(e.target.value)} value={course} required style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }} type="text" placeholder=" Enter Class & Course" />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '20px',flexDirection:isXs ? "":'column'  }}>
              <div style={{ display: 'flex', flexDirection: 'column', width:isXs ? '25%':'100%'}}>
                <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Experience</label>
                <input onChange={(e) => { const value = e.target.value; if (/^\d{0,2}$/.test(value)) { setExperience(value); } }} value={experience} required style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }} type="number" placeholder="Enter Experience" />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', width: isXs ? '22%':'100%' }}>
                <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="category">Select Year</label>
                <select onChange={(e) => setYear(e.target.value)} value={year} required
                  id="category"
                  style={{ height: '40px', borderRadius: '10px', border: '1px solid', paddingLeft: '10px' }}>
                  <option> </option>
                  <option value="Months">Months</option>
                  <option value="Years">Years</option>
                </select>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', width: isXs?  '50%':'100%', flexDirection: 'column' }}>
                <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="category">Upload Faculty Image</label>
                <label htmlFor="file" style={{ cursor: 'pointer', height: '40px', width: '100%', border: '1px solid #000', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '10px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontSize: '14px' }}>
                      {imagePreview ? (
                        <img style={{ border: '1px solid black' }} height={30} width={30} src={imagePreview} alt="Selected Preview" />
                      ) : (
                        <div style={{ border: '1px solid black', padding:'4px 15px', borderRadius: '7px', backgroundColor: 'gray', color: 'white' }}>
                          Upload Image
                        </div>
                      )}
                    </div>
                  </div>
                </label>
                <input
                  accept="image/*"
                  id="file"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />

              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <label style={{ fontSize: '16px', marginBottom: '6px', marginLeft: '10px', fontWeight: '500' }} htmlFor="title">Description</label>
              <textarea onChange={(e) => setDescription(e.target.value)} value={description} required style={{ borderRadius: '10px', border: '1px solid', paddingLeft: '10px', paddingTop: '10px', height: '120px' }} type="text" placeholder="Description" />
            </div>
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <button onClick={handleClose} style={{ backgroundColor: "#CB8B65", color: "white", padding: "10px 15px", borderRadius: "5px" }}>
          Cancel
        </button>
      </DialogActions>
    </Dialog>

    <Dialog open={open} onClose={handleCloseDelete}>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: ' 40px 30px' }}>
        <CloseIcon style={{ color: 'red', fontSize: '60px', padding: '10px', marginBottom: '20px', borderRadius: '50%', border: '2px solid red' }} />
        <div style={{ fontSize: '30px', textAlign: 'center', marginBottom: '20px' }}>
          Are you sure ?
        </div>
        <div style={{ textAlign: 'center', width: '320px', marginBottom: '20px' }}>Do you really want to delete this item? This Process cannot be undone. </div>
        <DialogActions style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <button
            onClick={handleCloseDelete}
            style={{ backgroundColor: "#9c9d9e", color: "white", padding: "7px 15px", borderRadius: "5px", marginRight: '10px', width: '100px', border: '0px' }}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            style={{ backgroundColor: "red", color: "white", padding: "7px 15px", borderRadius: "5px", width: '100px', border: "0px" }}
          >
            Yes
          </button>
        </DialogActions>
      </div>
    </Dialog>

  </>)
}

export default AllTeachers